export default "__VITE_ASSET__lKjDUY2v__"